import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const FloorList = () => {
  const [page, setPage] = useState(1);
  const [select, setSelect] = useState(0);
  const [tab, setTab] = useState(1);
  const [floorList, setFloorList] = useState([]);
  const navigate = useNavigate();
  const [cate, setCate] = useState('floor');
  const location = useLocation();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    getBoard();
  }, []);

  const getBoard = async () => {
    try {
      const response = await axios.get(`https://ciuc.or.kr:8443/api/get/floor_list?cate=${cate}&tab=${tab}`);
      setFloorList(response.data.data);
    } catch (error) {
      console.error('Error fetching floor list data', error);
    }
  };

  const handleSelect = (num) => {
    if (select === num) setSelect(0);
    else setSelect(num);
  };

  const handleTab = async (num) => {
    try {
      setTab(num);
      const response = await axios.get(`https://ciuc.or.kr:8443/api/get/floor_list?cate=${cate}&tab=${num}`);
      setFloorList(response.data.data);
    } catch (error) {
      console.error('Error fetching floor list data', error);
    }
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const getImageClass = (tabNumber) => {
    return `inquiry_img_${tabNumber}`;
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="sub_wrap board">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area business-field">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}기업연구동{' > '}층별안내
            </div>
            <div className="banner_main_text">층별안내</div>
          </div>
        </div>

        {/* 상단 네비 */}
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">기업연구동</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>

            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">층별안내</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  입주안내
                </div>
                <div className="select_row" onClick={() => movePage('/floor')}>
                  층별안내
                </div>
                <div className="select_row" onClick={() => movePage('/company')}>
                  입주기업현황
                </div>
                <div className="select_row" onClick={() => moveBoard('inquiry')}>
                  입주문의
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 */}
        <div className="sub_main_area board">
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>기업연구동</span>
                <div className="center_line"></div>
              </div>
            </div>

            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/inquiryinfo')}`} onClick={() => movePage('/inquiryinfo')}>
                <span>입주안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/floor')}`} onClick={() => movePage('/floor')}>
                <span>층별안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/company')}`} onClick={() => movePage('/company')}>
                <span>입주기업 현황</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/inquiry')}`}
                onClick={() => movePage('/board/inquiry')}
              >
                <span>입주문의</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* 층별 평면도 영역 */}
          <div className="board_container-sub floor_layout">
            <div className="floor_layout_card">
              {/* 좌측 층 리스트 */}
              <div className="floor_layout_left">
                <div className="floor_layout_title">층별 평면도</div>

                <div className="floor_layout_tab_list">
                  {[...Array(5)].map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      className={`floor_tab_item ${tab === index + 1 ? 'active' : ''}`}
                      onClick={() => handleTab(index + 1)}
                    >
                      <span className="floor_tab_label">{index + 1}F</span>
                      <span className="floor_tab_arrow">›</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* 우측 이미지 */}
              <div className="floor_layout_right">
                <div className="floor_layout_right_inner">
                  <div className="floor_badge">{tab}F</div>

                  <div className="floor_image_box">
                    <div className={`floor_image ${getImageClass(tab)}`} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 아래 리스트 */}
          <div className="board_container-sub floor_list_wrap">
            <div className="list_area">
              <div className="list_box">
                <table className="board_table">
                  <thead className="table_head">
                    <tr className="head_row">
                      <th className="head_section num">번호</th>
                      <th className="head_section title">호실</th>
                      <th className="head_section">시설명</th>
                      <th className="head_section date">작성자</th>
                      <th className="head_section date">등록일</th>
                    </tr>
                  </thead>
                  <tbody className="table_body">
                    {floorList.map((item, index) => (
                      <tr className="body_row" key={index}>
                        <td className="body_section num">{index + 1}</td>
                        <td className="body_section date">{item.room}</td>
                        <td className="body_section">{item.room_name}</td>
                        <td className="body_section date">{item.writer}</td>
                        <td className="body_section date">{formatDate(item.date)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloorList;
